import _ from 'lodash';

export default {
  namespace: 'travel',
  state: {},
  reducers: {
    setProducts(state, {items, meta}) {
      return {...state, items: items, orig: items, meta: meta};
    },
    selectProduct(state, {item}){
      return {...state, selectedItem: item };
    },
    /*
    switchView(state, {view}) {
      return {...state, view: view };
    },
    */
    /*
    setExRate(state, {exRate}) {
      console.info("travel/exRate", exRate);
      return {...state, exRate: exRate};
    },
    */
    search(state, {items, keyword}) {
//      console.info("travel/items:", items);
      return {...state, items: items, orig: items, searchKeyword: keyword};
    },
    /*
    toggleList(state){
      const toggle = !state.toggleList;
      return { ...state, toggleList: toggle };
    },
    */
    //-------------------------------------------------------------
    // Filter
    //-------------------------------------------------------------
    /**
     * Filtering price range
     * @param range
     * @returns {{filterPrice: *}}
     */
    /*
    filterPrice(state, {range}) {
      const _items = state.orig.filter(x => x.get('price') < range[1]);
      console.info("filter price: ", _items.size);
      return {...state, filterPrice: range, items: _items};
    },
    */
    /**
     * Filtering city
     * @param city
     * @returns {{filterPrice: *}}
     */
    /*
    filterCity(state, {value}) {
      console.info("filter city: ", value);
      let _items = [];
      if (value == 'all') {
        _items = state.orig;
      } else {
        _items = state.orig.filter(x => x.get('city_key') == value);
      }
      return {...state, filterCity: value, items: _items};
    },
    */
    //-------------------------------------------------------------
    // Sort
    //-------------------------------------------------------------
    /**
     * Sort Price
     * @param
     * @returns {{filterPrice: *}}
     */
    sortPrice(state) {
      //  const _items = state.orig.filter(x => x.get('price') < range[1]);
      let order = state.orderPrice?state.orderPrice:'asc';
//      const items = _.sortBy(state.orig, ['price']);

      const items = state.orig.sort((a, b) => {
        if (order == 'asc') {
          return a.price - b.price;
        } else {
          return b.price - a.price;
        }
      });

      order = (order == 'asc') ? 'desc' : 'asc';
      console.info('travel/sort['+ order+':', items);
      return {...state, orderPrice: order, items: items};
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/travel/models/travel.js